import { RelatoriosContext } from '@/contexts/RelatoriosContext';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { useContext } from 'react';
import { Button } from '@/components/ui/button';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';

export function Paginacao() {
  const ctx = useContext(RelatoriosContext);
  if (!ctx) {
    throw new Error('Paginacao deve ser usado dentro de <RelatoriosProvider>');
  }

  const { relatorios, paginaAtual, setPaginaAtual, itensPorPagina, setItensPorPagina } = ctx;

  const totalPaginas = Math.ceil(relatorios.length / itensPorPagina);
  const inicio = (paginaAtual - 1) * itensPorPagina + 1;
  const fim = Math.min(paginaAtual * itensPorPagina, relatorios.length);

  if (relatorios.length === 0) return null;

  return (
    <div className="flex flex-col sm:flex-row items-center justify-between gap-4 bg-card border border-border rounded-lg px-6 py-4">
      <div className="flex items-center gap-2">
        <span className="text-sm text-muted-foreground">Itens por página:</span>
        <Select
          value={itensPorPagina.toString()}
          onValueChange={value => {
            setItensPorPagina(Number(value));
            setPaginaAtual(1);
          }}
        >
          <SelectTrigger className="w-20">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="5">5</SelectItem>
            <SelectItem value="10">10</SelectItem>
            <SelectItem value="20">20</SelectItem>
            <SelectItem value="50">50</SelectItem>
          </SelectContent>
        </Select>
      </div>

      <div className="flex items-center gap-6">
        <span className="text-sm text-muted-foreground">
          Mostrando {inicio} a {fim} de {relatorios.length} resultados
        </span>

        <div className="flex items-center gap-2">
          <Button
            variant="outline"
            size="icon"
            onClick={() => setPaginaAtual(paginaAtual - 1)}
            disabled={paginaAtual === 1}
          >
            <ChevronLeft className="h-4 w-4" />
          </Button>

          <span className="text-sm font-medium px-4">
            Página {paginaAtual} de {totalPaginas}
          </span>

          <Button
            variant="outline"
            size="icon"
            onClick={() => setPaginaAtual(paginaAtual + 1)}
            disabled={paginaAtual === totalPaginas}
          >
            <ChevronRight className="h-4 w-4" />
          </Button>
        </div>
      </div>
    </div>
  );
}
